import _ from 'lodash';
import classNames from 'classnames';
import { isEpisode, isClip, isMovie } from 'helpers/ContentHelper';

export const RESTART_TYPE_LIVE = 'restart-live';
export const RESTART_TYPE_HOME = 'restart-home';

export const PANEL_TYPE_VIDEOS = 'videos';
export const VIDEO_TYPE_CLIP = 'clip';
export const VIDEO_TYPE_FULLEPISODE = 'fullEpisode';
export const VIDEO_TYPE_MOVIE = 'movie';
export const VIDEO_TYPE_GAME = 'game';
export const RELEASE_TYPE_LIVE = 'live';

export const getSectionTitleData = ({
  member,
  theme,
  primary,
  forceGrid,
  isPlaylist,
  panelVideo,
  sectionItems,
}) => {
  if (!member) return null;
  const {
    videoPage_headerEpisodes: headerEpisodes,
    videoPage_headerClips: headerClips,
    videoPage_headerMovies: headerMovies,
  } = window.Language;
  const headline = _.get(member, 'headline') || _.get(member, 'name');
  const items = _.get(member, 'items.member', null);
  const seriesName = _.get(items, '0.seriesName');
  const videoType = _.get(items, '0.videoType');
  const seasonNumber = panelVideo?.seasonNumber;
  const seasonName = panelVideo?.seasonName;
  const episodeCount = sectionItems ? `(${sectionItems.length})` : null;
  const seasonText = seasonNumber ? `Season ${seasonNumber}` : '';
  const defaultText = `${seriesName} ${headerEpisodes} ${episodeCount}`;
  const sectionTitleClass = classNames([
    primary ? theme.sectionTitlePrimary : null,
    forceGrid ? theme.sectionTitleGridForced : null,
    theme.sectionTitle,
  ]);
  const isEpisodeType = isEpisode(videoType);
  const isClipType = isClip(videoType);
  const isMovieType = isMovie(videoType);

  if (isPlaylist) return { sectionTitleClass, sectionTitle: headline };
  if (isEpisodeType)
    return {
      sectionTitleClass,
      sectionTitle: `${seriesName} - ${seasonName || seasonText || defaultText}`,
    };
  if (isClipType) return { sectionTitleClass, sectionTitle: `${seriesName} ${headerClips}` };
  if (isMovieType) return { sectionTitleClass, sectionTitle: headerMovies };
  if (headline) return { sectionTitleClass, sectionTitle: headline };
  return null;
};
